<script setup>
import { computed } from 'vue'
import formatDate from '@utils/format-date-full'
import PlaylistOptions from '@components/playlists/playlist-options'

const props = defineProps({
    playlist: {
        type: Object,
        default: () => null,
    },
    playlistMixes: {
        type: Array,
        default: () => [],
    },
})

defineEmits(['playPlaylist'])

const publishedTime = computed(() => {
    if (props.playlist && props.playlist.revisions_publish_time) {
        return formatDate(new Date(props.playlist.revisions_publish_time))
    }
    return ''
})
</script>

<template>
    <div
        v-if="playlist"
        class="playlist-info"
    >
        <div class="playlist-info-inner">
            <BaseResourceCover
                :image-resource="playlist"
                :media-resource="playlist"
                image-type="revisions_album_art"
                media-type="playlist"
                radius="card"
            >
                <template #secondaryActions>
                    <div>
                        <PlaylistOptions
                            :playlist="playlist"
                            :has-view-playlist-option="false"
                        />
                    </div>
                </template>
            </BaseResourceCover>
            <div class="title">
                <h5
                    v-if="playlist"
                    class="title-inner"
                >{{ playlist.revisions_title }}</h5>
                <div v-else>
                    <BasePlaceholder :size="10" />
                    <BasePlaceholder :size="13" />
                </div>
            </div>
            <div class="description">
                <div v-if="playlist">{{ playlist.revisions_description }}</div>
                <div v-else>
                    <BasePlaceholder :size="15" />
                    <BasePlaceholder :size="17" />
                </div>
            </div>
            <div class="button">
                <div
                    v-if="playlist"
                    @click="$emit('playPlaylist', 0)"
                >
                    <BaseButtonPlay
                        :icon="true"
                        :playlist="playlist"
                        class="button-inner"
                        :loading-playlist-mixes="true"
                        :resource="playlistMixes"
                    />
                </div>
                <div v-else>
                    <BasePlaceholder :size="7" />
                </div>
            </div>
            <div class="published-time">
                <div v-if="playlist && publishedTime">Last Updated: {{ publishedTime }}</div>
                <div v-else>
                    <BasePlaceholder :size="15" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.playlist-info-inner {
    margin-bottom: $s-xl;

    @include desktop {
        position: sticky;
        top: $s-m + $s-h; // 80px = the sticky desktop top bar (main-layout .top-bar-inner)
        margin-bottom: 0;
    }
}

.title {
    margin-top: $s-xxl;
    margin-bottom: $s-s;
    text-align: center;
}

.title-inner {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 800;
}

.description {
    @extend %contentTinyHeading;

    margin-top: 0;
    margin-bottom: $s-l;
    text-align: center;
}

.published-time {
    @extend %contentTinyHeading;

    text-align: center;
}

.button {
    text-align: center;
}

.button-inner {
    max-width: 240px;
}
</style>
